import cx from 'classnames';
import { FC } from 'react';
import { HeaderLogoProps } from './types';
import { CATCORP_LOGO_ALT_TEXT, LOGO_SIZES } from '../constants';

import styles from './HeaderLogo.module.scss';
import { MAIN_NAV_TRACK } from '../../../constants/analyticsConstants';

export const HeaderLogo: FC<HeaderLogoProps> = ({
  url,
  image,
  alt,
  isCatLogo = false,
  imgComp: Image = 'img'
}) => {
  const { width, height } = isCatLogo
    ? LOGO_SIZES.catLogo
    : LOGO_SIZES.dealerLogo;

  return (
    <a
      href={url}
      className={styles['header-logo__link']}
      data-track-event={MAIN_NAV_TRACK.EVENT}
      data-track-attr-nltext={MAIN_NAV_TRACK.LOGO_CLICK_TEXT}
      data-track-attr-context={MAIN_NAV_TRACK.TOP_MENU_CONTEXT}
    >
      <Image
        alt={alt || CATCORP_LOGO_ALT_TEXT}
        aria-label={alt || CATCORP_LOGO_ALT_TEXT}
        src={`${image}&wid=${width}&hei=${height}`}
        loading="lazy"
        width={width}
        height={height}
        className={cx(
          styles['header-logo__image'],
          isCatLogo
            ? styles['header-logo__image--catcorp']
            : styles['header-logo__image--dealer']
        )}
      />
    </a>
  );
};
